import React from 'react'
import { Typography,Container,Grid, Button } from '@mui/material'

import FullHeight from "react-full-height"
import Test from '../Test'

import Clock from '../../Assets/Home/clock.png'
import User from '../../Assets/Home/user.png'
import Design from '../../Assets/Home/design.png'
import Refund from "../../Assets/Home/refund.png"

import "@fontsource/questrial"
import "@fontsource/mukta"

const Section2 = () => {
  return (
    <div>
        
        <Container id="whyus" sx={{mt:10,p:4,textAlign:"center" }} >
          <Grid container >
              <Grid item md={5.45} sxs={12} sx={{p:4,mx:3,my:5,border:1,borderRadius:2,borderColor:"black",background:'rgba(255,255,255)'}}> 
                
                <img src={Clock} width={80} style={{margin:"20px 0px"}}/>
                
                <Typography variant="h5" style={{fontFamily:"Questrial",fontWeight:"600"}}>24 Hr Availability</Typography>
                <Typography variant="p" style={{fontFamily:"Mukta"}}>We value communication heavily, that is why we pride ourselves on being available around the clock. We believe that the client holds the vision of the site, therefore we work hand in hand with them to materialize that vision.</Typography>
            
              </Grid>
            <Grid item md={5.45} sxs={12} sx={{p:4,mx:3,my:5,border:1,borderRadius:2,borderColor:"black",background:'rgba(255,255,255)'}}> 
            
            <img src={User} width={80} style={{margin:"20px 0px"}}/>
              <Typography variant="h5" style={{fontFamily:"Questrial",fontWeight:"600"}}>Robust Backend</Typography>
                <Typography variant="p" style={{fontFamily:"Mukta"}}>The technologies we use to create our database allow for a large number of users and even larger user data. It is completely scalable and can grow in users with ease, it is <a rel="noreferrer"href="https://firebase.google.com/support/privacy" style={{textDecoration:'none'}} target="_blank">secure</a> and fast to ensure minimal latency by users.</Typography>
            </Grid>

            <Grid item md={5.45} sxs={12} sx={{p:4,mx:3,my:5,border:1,borderRadius:2,borderColor:"black",background:'rgba(255,255,255)'}}> 
            
            <img src={Design} width={80} style={{margin:"20px 0px"}}/>
            <Typography variant="h5" style={{fontFamily:"Questrial",fontWeight:"600"}}>Modern Deigns</Typography>
                <Typography variant="p" style={{fontFamily:"Mukta"}}>Our websites are always responsive to both big and small viewports to support whichever devise the user chooses. We incorporate 3D designs into our websites, and vector icons. We ensure low loading times to make the user experience as fluid as possible.</Typography>
            </Grid>
            <Grid item md={5.45} sxs={12} sx={{p:4,mx:3,my:5,border:1,borderRadius:2,borderColor:"black",background:'rgba(255,255,255)'}}> 
            
            <img src={Refund} width={80} style={{margin:"20px 0px"}}/>
            <Typography variant="h5" style={{fontFamily:"Questrial",fontWeight:"600"}}>Refunds</Typography>
                <Typography variant="p" style={{fontFamily:"Mukta"}}>In the rare event that a client is not satisfied with their website, we have a 30-day refund policy. 100% of the funds will be returned.</Typography>
            </Grid>

          </Grid>

          <Button variant="contained" sx={{mt:2}} style={{background:"black"}}><a style={{textDecoration:"none",color:"inherit"}} href="#howwecreate">HOW WE CREATE?</a></Button>
          <br></br>
          <Typography variant='"caption'>How the magic works</Typography>
        </Container>
       

    </div>
  )
}

export default Section2